/**
 * Created by Rishabh Kumar on 03-08-2018
* */

import * as React from "react"
import * as _ from "lodash";
import { IPastPsychiatricHistory, IMedicationInfo } from "@curefit/ehr-common";
import {AppConstants, AppPlaceholders} from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import CustomSelect from "../CustomSelect";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import TemplatedList from "../TemplatedList";
import ModelFactory from "../../models/ModelFactory";
import IDiagnosticSuggestions from "../../models/IDiagnosticSuggestions";
import IMedicineSuggestions from "../../models/IMedicineSuggestions";

export interface ConditionItemEditorProps {
    item: IPastPsychiatricHistory;
    onDataChange: (update: any) => any;
    disableFields?: boolean;
    fetchStaticSymptomData: (name: string) => Promise<any>;
    fetchStaticDiseasesData?: (input: string) => Promise<IDiagnosticSuggestions[]>;
    fetchMedicineByGenericName: (name: string) => Promise<IMedicineSuggestions[]>;
}

class PsychiatricHistoryItemEditor extends React.Component<ConditionItemEditorProps> {

    appendToRemoveKey = (pphItems: {item: IPastPsychiatricHistory}[]) => {
        let ItemsToReturn = pphItems;
        _.map(ItemsToReturn, (pphItem: {item: any}) => {
            if (pphItem.item.items.length === 0) {
                pphItem.item.showRemove = true;
            } else if (pphItem.item.items.length === 1) {
                if (ModelFactory.isConditionDetailsEmpty(pphItem.item.items[0]))
                    pphItem.item.showRemove = true;
                else
                    pphItem.item.showRemove = false;
            } else {
                pphItem.item.showRemove = false;
            }
        })
        return ItemsToReturn;
    };

    handleDataChange = (value: string, key: "appointmentYear" | "appointmentMonth") => {
        let updatedItem: IPastPsychiatricHistory = { ...this.props.item };
        updatedItem[key] = value;
        this.props.onDataChange(updatedItem);
    };

    handleItemRemove = (index: number) => {
        let currUpdatedPPH = { ...this.props.item };
        let currUpdatedPPHMedsList = Object.assign([], currUpdatedPPH.medicationInfoList);
        currUpdatedPPHMedsList.splice(index, 1);
        currUpdatedPPH.medicationInfoList = [ ...currUpdatedPPHMedsList ];
        this.props.onDataChange(currUpdatedPPH);
    };

    handleItemChange = (updatedItem: {item: IMedicationInfo}, index: number) => {
        let currUpdatedPPH: IPastPsychiatricHistory = {...this.props.item};
        currUpdatedPPH.medicationInfoList[index] = updatedItem.item;
        this.props.onDataChange(currUpdatedPPH);
    };

    onChiefComplaintChange = (input: string) => {
        let updatedItem = { ...this.props.item, chiefComplaintsDisplayValue: input };
        this.props.onDataChange(updatedItem);
        return this.props.fetchStaticSymptomData(input).then(symptoms => {
            let symptomTypeAhead: TypeAheadElement[] = [];
            _.map(symptoms, (symptom) => {
                let typeAheadElement: TypeAheadElement = {
                    value: symptom.id,
                    label: symptom.name
                };
                symptomTypeAhead.push(typeAheadElement);
            });
            return Promise.resolve({options: symptomTypeAhead, completed: true});
        }).catch(error => {
            throw error;
        });
    };

    onChiefComplaintSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, chiefComplaintsDisplayValue: elem.label, chiefComplaintsInternalValue: elem.value };
        this.props.onDataChange(updatedItem);
    };

    onDiagnosisChange = (input: string) => {
        let updatedItem = { ...this.props.item, diagnosisDisplayValue: input };
        this.props.onDataChange(updatedItem);
        return this.props.fetchStaticSymptomData(input).then(symptoms => {
            let symptomTypeAhead: TypeAheadElement[] = [];
            _.map(symptoms, (symptom) => {
                let typeAheadElement: TypeAheadElement = {
                    value: symptom.id,
                    label: symptom.name
                };
                symptomTypeAhead.push(typeAheadElement);
            });
            return Promise.resolve({options: symptomTypeAhead, completed: true});
        }).catch(error => {
            throw error;
        });
    };

    onDiagnosisSelect = (elem: TypeAheadElement) => {
        let updatedItem = { ...this.props.item, diagnosisDisplayValue: elem.label, diagnosisInternalValue: elem.value };
        this.props.onDataChange(updatedItem);
    };

    generateMedicinesList = (medicineList: IMedicationInfo[]) => {
        let updatedMedicineList: { item: IMedicationInfo }[] = [];
        _.map(medicineList, (medicine) => {
            updatedMedicineList.push({item: medicine});
        })
        return updatedMedicineList;
    }

    render () {
        let selectedMonth = this.props.item.appointmentMonth;
        let selectedYear = !_.isNull(this.props.item.appointmentYear) ? this.props.item.appointmentYear.toString() : "";
        let medicineList = !_.isEmpty(this.props.item.medicationInfoList) ? this.generateMedicinesList(this.props.item.medicationInfoList) : [];
        return (
            <div className={"psychiatric-history-item-editor"}>
                <div className={"psychiatric-single-items-wrapper in-blk"}>
                    <div className={"psychiatric-history-start-month in-blk psychiatric-field"}>
                        <CustomSelect selectedValue={selectedMonth} disabled={false} dropdownValues={AppUtils.generateMonthItems(AppConstants.monthsConstant, false)} defaultValue={"Month"} updateDropdownValue={(value) => this.handleDataChange(value, "appointmentMonth")}/>
                    </div>
                    <div className={"psychiatric-history-start-year in-blk psychiatric-field"}>
                        <CustomSelect disabled={false} dropdownValues={AppUtils.generateYearItems(null, "START")} selectedValue={selectedYear} defaultValue={"Year"} updateDropdownValue={(item) => this.handleDataChange(item, "appointmentYear")}/>
                    </div>
                    <div className={"psychiatric-chief-complaints in-blk psychiatric-field"}>
                        <TypeAhead widgetName={"PsychiatricHistoryItem"} name={"chief-complaint"} value={this.props.item.chiefComplaintsDisplayValue || ""} placeholder={AppPlaceholders.SYMPTOMS} onTypeAheadChange={this.onChiefComplaintChange} onTypeAheadSelect={this.onChiefComplaintSelect}/>
                    </div>
                    <div className={"psychiatric-history-diagnosis in-blk psychiatric-field"}>
                        <TypeAhead widgetName={"PsychiatricHistoryItem"} name={"diagnosis"} value={this.props.item.diagnosisDisplayValue || ""} placeholder={AppPlaceholders.DIAGNOSIS} onTypeAheadChange={this.onDiagnosisChange} onTypeAheadSelect={this.onDiagnosisSelect}/>
                    </div>
                </div>
                <div className={"psychiatric-repeated-items-wrapper in-blk"}>
                    <TemplatedList
                        commonProps={{fetchMedicineByGenericName: this.props.fetchMedicineByGenericName}}
                        templateName={"psychiatricRepeatingElements"}
                        listItems={medicineList}
                        defaultItem={{item: ModelFactory.createPPHMedicineItem()}}
                        onItemChange={this.handleItemChange}
                        onItemRemove={this.handleItemRemove}
                    />
                </div>
            </div>
        )
    }
}

export default PsychiatricHistoryItemEditor